import axios from "axios";
import { USER_LOGOUT, USER_AUTH_SUCCESS, GET_USER } from "../mutation-types";
import Api from "@/Api";
const state = {
    token: localStorage.getItem("gorsh_token") || "",
    user: JSON.parse(localStorage.getItem("gorsh_user")) || {}
};

const getters = {
    isLogged: state => !!state.token,
    user: state => state.user,
    purchaseMin: state => state.user.purchase_min, // 500
    purchaseMax: state =>
        state.user.purchase_max ? state.user.purchase_max : 30000000, // 0 means no limit
    discounts: state => state.user.discounts
};

const actions = {
    login(store, { email, password }) {
        return new Promise((resolve, reject) => {
            Api()
                .post("?func=auth", { email, password })
                .then(({ data }) => {
                    if (data.success) {
                        store.commit(USER_AUTH_SUCCESS, {
                            user: data.payload,
                            token: data.payload.hash
                        });
                        resolve();
                    } else {
                        reject(data.error.message);
                    }
                })
                .catch(() => {
                    reject("No pudimos conectarnos con el servidor!");
                });
        });
    },
    register(
        store,
        {
            nombre,
            cuit,
            calle,
            numero,
            piso,
            depto,
            localidad,
            provincia_id,
            email,
            password,
            password_repeat
        }
    ) {
        return new Promise((resolve, reject) => {
            if (password !== password_repeat)
                reject("la clave y la repeticción es invalida");
            Api()
                .post("?func=registerUser", {
                    data: {
                        nombre,
                        cuit,
                        calle,
                        numero,
                        piso,
                        depto,
                        localidad,
                        provincia_id,
                        email,
                        password,
                        password_repeat
                    }
                })
                .then(({ data }) => {
                    if (data !== "") {
                        if (data.success) {
                            store.commit(USER_AUTH_SUCCESS, {
                                user: data.payload,
                                token: data.payload.hash
                            });
                            resolve();
                        } else {
                            reject(data.error.message);
                        }
                    } else {
                        reject("el servidor no pudo procesar el registro.");
                    }
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    getUser(store, {}) {
        return new Promise((resolve, reject) => {
            Api()
                .get("?func=getUserData", {})
                .then(data => {
                    if (data.data.success) {
                        store.commit(GET_USER, { user: data.data.payload });
                        resolve(data.data.payload);
                    } else {
                        reject("");
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    logout(store) {
        store.commit(USER_LOGOUT);
    }
};

const mutations = {
    [GET_USER](store, { user }) {
        store.user = user;
        store.error = "";
        localStorage.setItem("gorsh_user", JSON.stringify(user));
    },
    [USER_AUTH_SUCCESS](store, { user, token }) {
        store.user = user;
        store.error = "";
        store.token = token;
        localStorage.setItem("gorsh_token", token);
        localStorage.setItem("gorsh_user", JSON.stringify(user));
        axios.defaults.headers.common["Authorization"] =
            localStorage.gorsh_token;
    },
    [USER_LOGOUT](store) {
        store.user = {};
        store.token = "";
        localStorage.clear();
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js